var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgDelete28 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 13V21H11V13H13Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 21V13H15V21H17Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 6V7H3V9H5.11719L6.89819 23.2481C7.0233 24.2489 7.87411 25 8.88275 25H19.1172C20.1258 25 20.9766 24.2489 21.1017 23.2481L22.8827 9H25V7H18V6C18 4.34315 16.6569 3 15 3H13C11.3431 3 10 4.34315 10 6ZM13 5C12.4477 5 12 5.44772 12 6V7H16V6C16 5.44772 15.5523 5 15 5H13ZM20.8672 9H7.13275L8.88275 23H19.1172L20.8672 9Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDelete28);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;